import React from 'react';
import { MeetingProposal } from '../../services/proposalService';

interface IncomingProposalsCardProps {
  incomingProposals: MeetingProposal[];
  user: any;
  selectedConnectionData: any;
  onSetAutoplanError: (error: string) => void;
  onSetProposalOpen: (open: boolean) => void;
  onHandleConnectionCTA: (action: any) => void;
  hasActiveScheduled: (data: any) => boolean;
  onAcceptProposal: (proposal: MeetingProposal, slot: { startTime: Date; endTime: Date }) => Promise<void>;
  onRejectProposal: (proposalId: string) => Promise<void>;
}

const IncomingProposalsCard: React.FC<IncomingProposalsCardProps> = ({
  incomingProposals,
  user,
  selectedConnectionData,
  onSetAutoplanError,
  onSetProposalOpen,
  onHandleConnectionCTA,
  hasActiveScheduled,
  onAcceptProposal,
  onRejectProposal,
}) => {
  if (incomingProposals.length === 0) {
    return null;
  }

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-3 space-y-2">
      <div className="font-medium text-green-800">Voorstellen van {selectedConnectionData?.name || 'onbekend'}</div>
      {incomingProposals.map((proposal) => (
        <div key={proposal.id} className="bg-white rounded border border-green-300 p-2 space-y-2">
          {proposal.suggestedSlots.map((slot, idx) => (
            <div key={idx} className="text-sm text-gray-800">
              {new Date(slot.startTime).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' })}{' '}
              {new Date(slot.startTime).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })} -{' '}
              {new Date(slot.endTime).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}
            </div>
          ))}
          {proposal.message && (
            <div className="text-xs text-gray-600 italic">"{proposal.message}"</div>
          )}
          <div className="flex space-x-2">
            {proposal.suggestedSlots.map((slot, slotIdx) => (
              <button
                key={slotIdx}
                onClick={async () => {
                  if (!user) return;
                  try {
                    await onAcceptProposal(proposal, slot);
                    onSetAutoplanError('Voorstel geaccepteerd!');
                    onSetProposalOpen(false);
                  } catch (err: any) {
                    onSetAutoplanError(err.message || 'Fout bij accepteren voorstel');
                  }
                }}
                className="px-2 py-1 bg-green-500 text-white rounded text-xs hover:bg-green-600"
              >
                Accepteer tijd {slotIdx + 1}
              </button>
            ))}
            <button
              onClick={async () => {
                if (!user || !proposal.id) return;
                try {
                  await onRejectProposal(proposal.id);
                  onSetAutoplanError('Voorstel geweigerd.');
                } catch (err: any) {
                  onSetAutoplanError(err.message || 'Fout bij weigeren voorstel');
                }
              }}
              className="px-2 py-1 bg-gray-200 text-gray-700 rounded text-xs hover:bg-gray-300"
            >
              Weiger
            </button>
          </div>
        </div>
      ))}
      {hasActiveScheduled(selectedConnectionData) && (
        <div className="mt-2">
          <button
            onClick={() => onHandleConnectionCTA('agenda')}
            className="px-2 py-1 bg-orange-500 text-white rounded text-xs hover:bg-orange-600"
          >
            Open planning
          </button>
        </div>
      )}
    </div>
  );
};

export default IncomingProposalsCard;






